import script from "./my-upload-imgs.vue?vue&type=script&setup=true&lang=js"
export * from "./my-upload-imgs.vue?vue&type=script&setup=true&lang=js"

import "./my-upload-imgs.vue?vue&type=style&index=0&id=fdc89392&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdc89392"]])

export default __exports__